<template>
  <Navbar @update-mycourses="handleNotificationsUpdate" />
  <div class="content-wrapper " :class="activePromotion? 'pt-20' : 'pt-40'">
    <div class="main-content overflow-hidden">
      <div class="container" :class="activePromotion? 'pt-40' : 'pt-50'">
        <div class="sectionTitle pb-20">
          <h1 class="sectionTitle__title mb-5"> {{ $t('myCourses') }} </h1>
        </div>

        <div v-if="loading">
          <Loader />
        </div>

        <div data-aos="fade-up" :data-aos-delay="200" v-else>

          <div class="row" v-if="myCourses.length > 0">
            <div class="col-lg-3 col-md-6 mb-15 d-flex flex-column" v-for="course in myCourses" :key="course.uuid">
              <MyCourseCard :showPrice="true" :item="course" />
            </div>
          </div>

          <div  class="empty-courses-message text-center py-5" v-else>
            <div class="mt-25 mb-25">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="124" height="124" fill="none" viewBox="0 0 24 24">
                <path stroke="#ddd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023" />
              </svg>

            </div>
            <h2>{{ $t('noCoursesFound') }}</h2>
            <p class="mt-15">
              {{ $t('noCoursesMessage') }}
            </p>
            <router-link to="/courses" class="main-button mt-25 px-30">
              {{ $t('browseCourses.title') }}
            </router-link>
          </div>
        </div>

      </div>
    </div>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Loader from "@/components/common/Loader.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
import MyCourseCard from "@/components/common/MyCourseCard.vue";
export default {
  components: {
    Navbar,
    Loader,
    MyCourseCard,
    FooterItem,
  },
  data() {
    return {
      myCourses: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    handleNotificationsUpdate(notifications, loading) {
      this.myCourses = notifications,
        this.loading = loading
    },

    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية - بلاننج فورس | ابدأ رحلتك التعليمية الآن"
          : "Courses - Planning Force | Start Your Learning Journey Now";

      const description =
        this.currentLanguage === "ar"
          ? "انضم إلى مجموعة متنوعة من الدورات التدريبية المصممة لتطوير مهاراتك وتحقيق طموحاتك المهنية والشخصية مع بلاننج فورس."
          : "Join a diverse range of courses designed to enhance your skills and achieve your professional and personal ambitions with Planning Force.";

      const keywords =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية, التعليم الإلكتروني, تطوير المهارات, التعلم عبر الإنترنت, بلاننج فورس"
          : "courses, e-learning, skill development, online learning, Planning Force";

      const author =
        this.currentLanguage === "ar"
          ? "معهد بلاننج فورس العالي للتدريب"
          : "Planning Force High Institute for Training";

      const language = this.currentLanguage === "ar" ? "ar" : "en";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          { name: "author", content: author },
          { name: "language", content: language },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
        ],
      });
    }
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
    isAuthenticated(newValue){
      if(newValue === false){
        this.$router.push('/');
      }
    }
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>